import React, {
  ReactElement,
  useCallback,
  useEffect,
  useState,
  useTransition,
} from "react";
import "./index.scss";
import {
  AllInvoice,
  InvoicingStatistic,
  InvoicingRequest,
  getInvoiceUrl,
  cancelInvoice,
} from "../../../api/personal";
import dayjs from "dayjs";
import { Button, Modal, Spin, message } from "antd";
import { useTranslation } from "react-i18next";
import { SvgIcon } from "@/components/SvgIcon";
import InfiniteScroll from "react-infinite-scroll-component";
import { goHref } from "@/utils/tool";

import InvoiceStep1 from "@/components/Modal/Invoicing/Step1";
import InvoiceModal from "@/components/Modal/Invoice";
import sentry4Action from "@/utils/sentry";
import { BillStatus, BillType, InvoiceTypeMap } from "@/utils/contants";

// TODO: 这里可以直接用数组做Map
const InvoiceStatusMap = {
  1: {
    title: "开票中",
    color: "--kx-Success-6",
  },
  2: {
    title: "已开票",
    color: "--kx-text-2",
  },
  3: {
    title: "作废中",
    color: "--kx-Error-6",
  },
  4: {
    title: "已作废",
    color: "--kx-text-3",
  },
  5: {
    title: "已取消",
    color: "--kx-text-3",
  },
};

const All: React.FC = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [showStep1, setShowStep1] = useState(false);
  const [showStep2, setShowStep2] = useState(false);
  const [invoiceStep2Param, setInvoiceStep2Param] = useState<{
    money: number;
    orderIds: Array<string>;
    orderType: OrderType;
  }>();
  const [pageNumber, setPageNumber] = useState(1);
  const [list, setList] = useState<Invoice[]>([]);
  const [spinning, setSpinning] = useState(true);
  const [staticInfo, setStaticInfo] = useState({
    free_bill_money: 0,
    // used_bill_money: 0,
    orderType: 1,
  });
  const { t } = useTranslation();
  const [modalInstance, setModalInstance] = useState<ReactElement<
    any,
    any
  > | null>(null);
  const [_, startTransition] = useTransition();
  const [cancelModal, setCancelModal] = useState(false);

  const fetchOrderList = async (p: number) => {
    setSpinning(true);
    const res = await AllInvoice<{
      count: number;
      list: Array<Invoice>;
      n: number;
      p: number;
    }>({
      p,
      n: 10,
    });
    setSpinning(false);
    if (res.code === 0) {
      const { list } = res.data;
      setList((pre) => [...pre, ...list]);
      // setList([])
      return;
    }
    messageApi.error(res.msg);
  };

  useEffect(() => {
    fetchOrderList(pageNumber);
  }, [pageNumber]);

  const fetchInvoiceStatic = async () => {
    const res = await InvoicingStatistic<{
      //   free_bill_money: number;
      //   used_bill_money: number;
      order_types: Array<{
        free_bill_money: number;
        last_order_pay_time: number;
        order_type: OrderType;
      }>;
    }>();
    if (res.code === 0) {
      const { order_types = [] } = res.data;
      if (order_types.length === 0) return;
      let free_bill_money = 0;
      let orderType = 1;
      free_bill_money = order_types.reduce(
        (pre, item) => pre + item.free_bill_money,
        free_bill_money
      );
      const orderTypes = order_types.filter((item) => item.free_bill_money > 0);
      if (orderTypes.length === 0) return;
      orderType = orderTypes.reduce((maxItem, currentItem) => {
        return currentItem.last_order_pay_time > maxItem.last_order_pay_time
          ? currentItem
          : maxItem;
      }, orderTypes[0]).order_type;

      setStaticInfo({ free_bill_money, orderType });
    }
  };
  useEffect(() => {
    fetchInvoiceStatic();
  }, []);

  const InvoicingStep2SubmitAction = async (params) => {
    const res = await InvoicingRequest(params);
    if (res.code === 0) {
      setList([]);
      startTransition(() => {
        fetchOrderList(1);
      });
      fetchInvoiceStatic();
    } else {
      messageApi.error(res.msg);
    }
  };

  const InvoicingStep1SubmitAction = async (param) => {
    setInvoiceStep2Param(param);
    setShowStep1(false);
    setShowStep2(true);
  };

  const invoicing = useCallback(async (freeBillMoney: number) => {
    sentry4Action("个人中心-开具发票", {});
    if (freeBillMoney == 0) {
      messageApi.info(t("可开票金额为0"));
    } else {
      setShowStep1(true);
    }
  }, []);

  const downloadInvoice = async (bill_id) => {
    const res = await getInvoiceUrl<{
      url: string;
    }>({ bill_id });
    if (res.code === 0) {
      const { data } = res;
      goHref(data.url);
      //   window.open(data.url, "_blank", "noopener, noreferrer");
    }
  };
  const downloadPowerOfAttorney = async (url: string) => {
    goHref(url);
    // window.open(url, "_blank", "noopener, noreferrer");
  };

  return (
    <section className="all-wrapper">
      {contextHolder}
      <div className="title" style={{ height: "40px" }}>
        <div className="text">
          <div>
            {t("可开票金额")}: ¥ {staticInfo.free_bill_money.toFixed(2)}
          </div>
        </div>
        <Button
          onClick={() => invoicing(staticInfo.free_bill_money)}
          className="btn-primary"
        >
          {t("开具发票")}
        </Button>
        {modalInstance}
      </div>
      {list.length !== 0 ? (
        <section className="list-wrapper" id="allScrollableEl">
          <>
            <InfiniteScroll
              dataLength={list.length}
              next={() => setPageNumber(pageNumber + 1)}
              hasMore={true}
              loader={null}
              scrollableTarget="allScrollableEl"
            >
              {list.map((item, index) => {
                return (
                  <div className="list-item" key={index}>
                    <div className="number">
                      <div>
                        <span>{t("申请编号")}:</span>
                        <span> {item.bill_id}</span>
                      </div>
                      <div
                        style={{
                          color: `var(${InvoiceStatusMap[item.status].color})`,
                        }}
                      >
                        {t(InvoiceStatusMap[item.status].title)}
                      </div>
                    </div>
                    <section className="info-wrapper">
                      <div className="periodicals">
                        <span className="title">{t("发票类型")}:</span>
                        {t(InvoiceTypeMap[item.bill_type])}
                      </div>
                      <div className="article-title">
                        <span className="title">{t("发票抬头")}:</span>
                        {item.bill_title}
                      </div>
                      <div className="pay-time">
                        <span className="title">{t("申请开票时间")}:</span>
                        {dayjs(item.create_time * 1000).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                      </div>
                      {item.cancel_reason && (
                        <div className="pay-time">
                          <span className="title">{t("备注")}:</span>
                          <span className="reason">{item.cancel_reason}</span>
                        </div>
                      )}
                      <div className="pay-amount">
                        <div className="money">
                          <span>{t("开票金额")}:</span>
                          <div className="money-content">
                            <span>¥</span>
                            <span>{item.bill_money.toFixed(2)}</span>
                          </div>
                        </div>

                        {item.power_of_attorney && (
                          <Button
                            onClick={() =>
                              downloadPowerOfAttorney(item.power_of_attorney)
                            }
                            className="btn-download"
                          >
                            {t("下载出版社授权书")}
                          </Button>
                        )}
                        {item.status == 2 && (
                          <Button
                            onClick={() => {
                              const diffDay = dayjs().diff(
                                dayjs(item.create_time * 1000),
                                "day"
                              );
                              const diffHour = dayjs().diff(
                                dayjs(item.create_time * 1000),
                                "hour"
                              );
                              const diffMins = dayjs().diff(
                                dayjs(item.create_time * 1000),
                                "minute"
                              );
                              if (diffDay > 90) {
                                Modal.info({
                                  title: t("提示"),
                                  centered: true,
                                  okText: t("确认"),
                                  content: (
                                    <div>
                                      <div>
                                        {t(
                                          "已开具的发票仅支持90天内作废发票，超过90天请联系客服：publink@cnpiec.com.cn"
                                        )}
                                      </div>
                                    </div>
                                  ),
                                });
                              } else {
                                Modal.confirm({
                                  title: t("提示"),
                                  centered: true,
                                  onOk: async () => {
                                    const bill_id = item.bill_id;
                                    const res = await cancelInvoice({
                                      bill_id,
                                    });
                                    if (res.code === 0) {
                                      message.info(t("作废发票成功"));
                                      setList([]);
                                      startTransition(() => {
                                        fetchOrderList(1);
                                      });
                                      fetchInvoiceStatic();
                                    } else {
                                      messageApi.error(res.msg);
                                    }
                                    return Promise.resolve();
                                  },
                                  okText: t("确认"),
                                  content: (
                                    <div>
                                      <div>
                                        {t(
                                          "是否作废发票，作废后该发票将无法被用于报销等"
                                        )}
                                      </div>
                                      <div>
                                        {t("作废后您可在“开具发票”中重新开票")}
                                      </div>
                                    </div>
                                  ),
                                });
                              }
                            }}
                            className="btn-download"
                          >
                            {t("作废发票")}
                          </Button>
                        )}
                        {/* 1.电子发票 2. 已发票*/}
                        {[
                          BillType.ElectronicOrdinaryInvoice,
                          BillType.ElectronicGeneral,
                          BillType.ElectronicSpecial,
                        ].includes(item.bill_type) &&
                          item.status == BillStatus.Invoiced && (
                            <Button
                              onClick={() => downloadInvoice(item.bill_id)}
                              className="btn-download"
                            >
                              {t("下载发票")}
                            </Button>
                          )}
                      </div>
                    </section>
                  </div>
                );
              })}
            </InfiniteScroll>
            {spinning && (
              <div className="spin-wrapper">
                <Spin size="large" spinning={spinning} />
              </div>
            )}
          </>
        </section>
      ) : (
        <div className="empty-content" style={{ marginTop: "1.583rem" }}>
          <SvgIcon icon="icon-wuliebiao" />
          {t("暂无发票")}
        </div>
      )}
      {showStep1 && (
        <InvoiceStep1
          hiddenModal={() => setShowStep1(false)}
          submitAction={(params) => InvoicingStep1SubmitAction(params)}
          //   freeBillMoney={staticInfo.free_bill_money}
          orderType={staticInfo.orderType as OrderType}
        />
      )}
      {showStep2 && (
        <InvoiceModal
          hiddenModal={() => setShowStep2(false)}
          additionalParams={invoiceStep2Param}
          submitAction={(info) => InvoicingStep2SubmitAction(info)}
          orderIds={invoiceStep2Param?.orderIds}
        />
      )}
    </section>
  );
};

export default All;
